// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule, Location, ViewportScroller } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizedDatePipe } from 'src/app/modules/shared/pipes/localizedDate.pipe';
import { ScreenLayoutService } from 'src/app/modules/shared/services/screen-layout-service/screen-layout.service';
import { DateRangeService } from '../../services/date-range/date-range.service';

@Component({
  selector: 'app-coil-phone-view',
  templateUrl: './coil-phone-view.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, LocalizedDatePipe],
  styleUrls: ['./coil-phone-view.component.scss'],
})
export class CoilPhoneViewComponent implements OnInit {
  systemSerialNumber: string | null = null;
  systemMaterialNumber: string | null = null;

  coilName: string | null = null;
  dayOfWeek: string | null = null;
  calDay: string | null = null;
  coilChannelIcon: string[] = [];
  coilHistoryIcon: string | null = null;
  styles: { [key: string]: string } = {};

  filteredEntries: { entries: string[] }[] = [];
  coilElements: string[] = [];
  rgbaValues: string[] = [];

  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  readonly screenLayoutService = inject(ScreenLayoutService);
  readonly dateRangeService = inject(DateRangeService);
  readonly reversedDateRange$ = this.dateRangeService.reversedDateRange$;
  private viewportScroller = inject(ViewportScroller);

  ngOnInit(): void {
    this.setCoilHistoryParams();
    this.splitFilteredEntries();
    this.setIcons();
    this.scrollToTop();
  }

  setCoilHistoryParams(): void {
    const paramMap = this.activatedRoute.snapshot.paramMap;
    this.systemMaterialNumber = paramMap.get('systemMaterialNumber');
    this.systemSerialNumber = paramMap.get('systemSerialNumber');

    this.coilName = paramMap.get('coilName');
    this.dayOfWeek = paramMap.get('dayOfWeek');
    this.calDay = paramMap.get('calDay');
    this.coilHistoryIcon = paramMap.get('icon');

    try {
      this.styles = JSON.parse(paramMap.get('styles') || '{}');
    } catch {
      this.styles = {};
    }

    try {
      this.filteredEntries = JSON.parse(
        paramMap.get('filteredEntries') || '[]'
      );
    } catch {
      this.filteredEntries = [];
    }
  }

  goBack(): void {
    this.location.back();
  }

  splitFilteredEntries(): void {
    this.filteredEntries.forEach((entry: { entries: string[] }) => {
      entry.entries.forEach((item) => {
        const [tValue, rgbaValue] = item.split(' - ');
        this.coilElements.push(tValue);
        this.rgbaValues.push(rgbaValue);
      });
    });
  }

  setIcons(): void {
    this.rgbaValues.forEach((rgbaValue) => {
      switch (rgbaValue) {
        case 'rgba(var(--functional-red), var(--opacity-1))':
          this.coilChannelIcon.push('error');
          break;
        case 'rgba(var(--functional-green), var(--opacity-1))':
          this.coilChannelIcon.push('success');
          break;
        case 'var(--base-1)':
          this.coilChannelIcon.push('assets/dot.svg');
          break;
        default:
          this.coilChannelIcon.push('');
          break;
      }
    });
  }

  setSmallGreyIcon(icon: string): boolean {
    return icon === 'assets/dot.svg';
  }

  scrollToTop(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
